import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { FormControl } from "react-bootstrap";

class CampaignsMeta extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      author: this.props.campaign.author,
      category: this.props.campaign.category,
      description: this.props.campaign.description
    };
  }

  componentDidMount() {
    this.delayedCallback = _.debounce(function(callback) {
      callback();
    }, 500);
  }

  saveMeta() {
    this.props.handleSave(this.props.campaign.id, {
      author: this.state.author,
      category: this.state.category,
      description: this.state.description
    });
  }

  handleChange(e) {
    let { name, value } = e.target;
    this.setState(
      {
        [name]: value
      },
      function() {
        this.delayedCallback(this.saveMeta.bind(this));
      }.bind(this)
    );
  }

  categoryOptions() {
    let categories = ["", "Buyer", "Seller", "Expired"];
    let options = categories.map(category => {
      let selected = "";
      if (this.state.category == category) {
        selected = "selected";
      }
      return (
        <option key={category} value={category} selected={selected}>
          {category}
        </option>
      );
    });
    return options;
  }

  render() {
    return (
      <div>
        <form className="meta_form">
          <label>Author</label>
          <FormControl
            componentClass="input"
            type="text"
            name="author"
            className="form-control starter_campaign_meta_author"
            labelClassName=""
            wrapperClassName=""
            size={this.state.authorSize}
            value={this.state.author}
            onChange={this.handleChange.bind(this)}
          />
          <label>Category</label>
          <FormControl
            componentClass="select"
            type="select"
            className="form-control starter_campaign_meta_category"
            onChange={this.handleChange.bind(this)}
            wrapperClassName="p-0"
            name="category"
          >
            {this.categoryOptions()}
          </FormControl>
          <label>Description</label>
          <textarea
            type="text"
            name="description"
            className="form-control starter_campaign_meta_description m-b-30"
            labelClassName=""
            wrapperClassName=""
            value={this.state.description}
            onChange={this.handleChange.bind(this)}
          />
        </form>
      </div>
    );
  }
}

export default CampaignsMeta;
